import { __rest } from '../../../../../../_virtual/_tslib.js';
import React, { useContext, useRef, useEffect } from 'react';
import { useDropdownMenu } from '@lwt-helix/useDropdownMenu';
import DropdownMenu from './DropdownMenu.js';
import { StyledUserMenu } from './Navbar.styles.js';
import DropdownMenuItem from './DropdownMenuItem.js';
import { NavbarContext } from './NavbarContext.js';
import ProfileIcon from './ProfileIcon.js';
import { clickDropdownItem } from './NavbarHelpers.js';

var NavbarUserMenu = function NavbarUserMenu(_a) {
  var _a$menuItems = _a.menuItems,
      menuItems = _a$menuItems === void 0 ? [] : _a$menuItems,
      _a$dataLwtId = _a.dataLwtId,
      dataLwtId = _a$dataLwtId === void 0 ? 'navbar-user-menu' : _a$dataLwtId,
      className = _a.className,
      linkWrapper = _a.linkWrapper,
      user = _a.user,
      location = _a.location,
      rest = __rest(_a, ["menuItems", "dataLwtId", "className", "linkWrapper", "user", "location"]);

  var _useDropdownMenu = useDropdownMenu({
    placement: 'bottom-end',
    items: menuItems,
    resetSelectedItemOnClose: true,
    itemToString: function itemToString(item) {
      return item.label ? item.label : '';
    },
    offset: [0, 8]
  }),
      isOpen = _useDropdownMenu.isOpen,
      getToggleButtonProps = _useDropdownMenu.getToggleButtonProps,
      getMenuProps = _useDropdownMenu.getMenuProps,
      highlightedIndex = _useDropdownMenu.highlightedIndex,
      getItemProps = _useDropdownMenu.getItemProps,
      setReferenceElement = _useDropdownMenu.setReferenceElement,
      setPopperElement = _useDropdownMenu.setPopperElement,
      attributes = _useDropdownMenu.attributes,
      styles = _useDropdownMenu.styles;

  var _useContext = useContext(NavbarContext),
      setUserMenuItems = _useContext.setUserMenuItems,
      setUserMenuLocation = _useContext.setUserMenuLocation,
      setUserMenuLinkWrapper = _useContext.setUserMenuLinkWrapper,
      setUserInfo = _useContext.setUserInfo;

  var menuRef = useRef(null);
  useEffect(function () {
    setUserMenuItems(menuItems);
  }, [menuItems]);
  useEffect(function () {
    if (user && setUserInfo) {
      setUserInfo(user);
    }
  }, [user]);
  useEffect(function () {
    if (linkWrapper) {
      setUserMenuLinkWrapper(function () {
        return linkWrapper;
      });
    }
  }, [linkWrapper]);
  useEffect(function () {
    if (location && location.pathname) {
      setUserMenuLocation(location.pathname);
    }
  }, [location]);

  var isActive = function isActive() {
    return menuItems ? menuItems.filter(function (item) {
      return item.active;
    }).length > 0 || location && menuItems.filter(function (item) {
      return item.url === (location === null || location === void 0 ? void 0 : location.pathname);
    }).length > 0 : false;
  };

  var handleKeyDown = function handleKeyDown(e) {
    clickDropdownItem(e, menuRef);
  };

  return React.createElement(StyledUserMenu, Object.assign({
    ref: setReferenceElement,
    className: "helix-unified-nav__additional-nav-item helix-unified-nav__additional-user-menu-toggle ".concat(className ? className : ''),
    "data-lwt-id": dataLwtId
  }, rest), React.createElement("button", Object.assign({}, getToggleButtonProps(), {
    "aria-label": 'User Menu',
    className: "helix-unified-nav__nav-button helix-unified-nav__nav-button-user ".concat(isActive() ? 'active' : '')
  }), (user === null || user === void 0 ? void 0 : user.avatarURL) ? React.createElement("div", {
    className: 'helix-unified-nav__user-avatar'
  }, React.createElement("img", {
    src: user.avatarURL,
    alt: 'avatar'
  })) : React.createElement(ProfileIcon, null)), React.createElement(DropdownMenu, Object.assign({
    inNavbar: true,
    maxWidth: '300px',
    ref: setPopperElement,
    isOpen: isOpen,
    style: styles.popper,
    className: 'helix-unified-nav__user-dropdown-menu'
  }, attributes.popper), React.createElement("ul", Object.assign({}, getMenuProps({
    onKeyDown: function onKeyDown(e) {
      return handleKeyDown(e);
    },
    ref: function ref(_ref) {
      return menuRef.current = _ref;
    }
  })), isOpen && menuItems && menuItems.length > 0 && menuItems.map(function (item, index) {
    return React.createElement(DropdownMenuItem, {
      menuItem: item,
      index: index,
      linkWrapper: linkWrapper,
      highlightedIndex: highlightedIndex,
      getItemProps: getItemProps,
      key: "".concat(item.label).concat(index),
      className: location && location.pathname === item.url ? 'active' : ''
    });
  }))));
};

export { NavbarUserMenu as default };